import { Link } from "react-router-dom";
import { Globe } from "lucide-react";
import { useLang } from "../context/LangContext";
import { WHATSAPP_DISPLAY, TELEGRAM_DISPLAY, WHATSAPP_URL, TELEGRAM_URL, OFFICIAL_URL, scrollToId } from "../constants";
import { Logo, WhatsAppIcon, TelegramIcon } from "./icons";

export const Footer = () => {
  const { t, lang } = useLang();
  const f = t.footer;
  const official = lang === "cn" ? "官方网站" : "Official Website";

  return (
    <footer className="relative border-t border-white/5 pb-20 pt-16 md:pb-8">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1.2fr]">
          <div>
            <Logo t={f.tagline} />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-500">{f.tagline}</p>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400">{f.menuTitle}</p>
            <ul className="mt-5 space-y-3">
              {f.menu.map((m) => (
                <li key={m.id}>
                  <button
                    data-testid={`footer-nav-${m.id}`}
                    onClick={() => scrollToId(m.id)}
                    className="text-sm text-slate-500 transition-colors hover:text-white"
                  >
                    {m.label}
                  </button>
                </li>
              ))}
              <li>
                <a
                  href={OFFICIAL_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-official-link"
                  className="group flex items-center gap-1.5 text-sm text-slate-500 transition-colors hover:text-blue-300"
                >
                  <Globe className="h-3.5 w-3.5" />
                  {official}
                  <span className="text-xs text-slate-600 group-hover:text-blue-400">· mbpayvia.com</span>
                </a>
              </li>
            </ul>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400">{f.legalTitle}</p>
            <ul className="mt-5 space-y-3">
              {f.legal.map((l) => (
                <li key={l.key}>
                  <Link
                    to={`/${l.key}`}
                    data-testid={`legal-${l.key}-link`}
                    className="text-sm text-slate-500 transition-colors hover:text-white"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400">{f.contactTitle}</p>
            <ul className="mt-5 space-y-3">
              <li>
                <a
                  href={WHATSAPP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp-link"
                  className="flex items-center gap-2.5 text-sm text-slate-500 transition-colors hover:text-white"
                >
                  <WhatsAppIcon className="h-4 w-4 text-green-500" />
                  WhatsApp · {WHATSAPP_DISPLAY}
                </a>
              </li>
              <li>
                <a
                  href={TELEGRAM_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-telegram-link"
                  className="flex items-center gap-2.5 text-sm text-slate-500 transition-colors hover:text-white"
                >
                  <TelegramIcon className="h-4 w-4 text-sky-400" />
                  Telegram · {TELEGRAM_DISPLAY}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 border-t border-white/5 pt-8">
          <p className="mx-auto max-w-4xl text-[11px] leading-relaxed text-slate-600">{f.disclaimerText}</p>
          <p className="mx-auto mt-2 max-w-4xl text-[11px] leading-relaxed text-slate-600">{f.disclaimerExtra}</p>
          <p className="mt-6 text-center text-xs text-slate-600">
            © 2026 MB PAY VIA · {f.rights}
          </p>
        </div>
      </div>
    </footer>
  );
};
